module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAABaElEQVRIibXVv2vVUBgG4OeWXiehgw4dFcRJOBS6WScPLoI3DoqDRVrFf8G1ruLgJhRB8dci4gGhHZpRcOjS0LVQabdOglIUHRxKHaRJTnLtu74535Ph5MtgtLYhM5ewgDkMsYu3eJZi+N12eJAJvcCdmm4b11MMVdOAiQzkVQMCZ7FelNX0ONAN3M54mSE+9oVO4GkGcpjZoqyu9YHmcKoDBLf6QKEjAjN9oNM9oPNFWU11hX71gL7iR1foSw/oc4rhZ1dopQf0vK5ogvbwsAOymWJ43weCJWxlQqOmMmcFXcb3lmfmUwzb40I7WGzoH6UYXrcNyYGo32O7KYYHOQNyobphw8zzrdAZB1d2qaafLspqvSirC21Q3Y/vCm5i3sEWz8kbfMBqimG/CZrEPdzFbObwo7KHd1hJMfz96A+hq3iCc2MAR2UTj1MMLwejtY2L+PSfgX+zPIHlY0bg/iRO4tsxQ/t/AF2uUY6XdB/LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 1